import React, { useState, useMemo } from "react";

// DevExtreme components
import ContextMenu from 'devextreme-react/context-menu';

export function DefaultWidgetContextMenu(props) {
  const { widgetId, hideClipboardOption, hideDeleteOption, editable, onCopy, onPaste, onDelete, getContextActions } = props;
  const [customItems, setCustomItems] = useState({ items: [], fetched: false });
  const targetId = "contextMenuFor" + (widgetId ? widgetId : new Date().getTime());

  const allMenuItemsMemo = useMemo(() => {
    const defaultMenuItems = [
      {
        "text": "Clipboard",
        "disabled": (onCopy === undefined && onPaste === undefined),
        "visible": (hideClipboardOption !== true),
        "items": [
          {
            "text": "Copy",
            "disabled": (onCopy === undefined),
            "action": () => copyToClipboardAction()
          },
          {
            "text": "Paste",
            "disabled": (editable === false || onPaste === undefined),
            "action": () => pasteFromClipboardAction()
          }
        ]
      },
      {
        "text": "Delete",
        "disabled": (editable === false || onDelete === undefined),
        "visible": (hideDeleteOption !== true),
        "action": () => deleteValue()
      }
    ];

    return [...defaultMenuItems, ...customItems.items];
  }, [copyToClipboardAction, pasteFromClipboardAction, deleteValue, customItems.items]);

  function copyToClipboardAction() {
    let contentToCopy = onCopy();
    navigator.clipboard.writeText(contentToCopy)
      .then(() => {
        console.log("Copied from Widget: " + widgetId, contentToCopy);
      });
  };

  function pasteFromClipboardAction() {
    navigator.clipboard.readText()
      .then(contentToPaste => {
        console.log("Pasting into Widget: " + widgetId, contentToPaste);
        onPaste(contentToPaste);
      });
  };

  function deleteValue() {
    new Promise(resolve => setTimeout(resolve, 10))
      .then(() => {
        console.log("Deleting value of Widget: " + widgetId);
        onDelete();
      });
  };

  const contextMenuOnShowing = async (args) => {
    if (getContextActions && !customItems.fetched) {
      let result = await getContextActions();
      setCustomItems({ items: result, fetched: true });
    }
  };

  const contextMenuItemClick = (args) => {
    let executeAction = args.itemData.action;
    if (executeAction === undefined) return;
    console.log("Executing ContextMenu Action for Widget: " + widgetId, executeAction);
    executeAction();
  };

  return (
    <div id={targetId} style={{ width: "100%", height: "100%" }}>
      {props.children}
      <ContextMenu
        dataSource={allMenuItemsMemo}
        onShowing={contextMenuOnShowing}
        target={"#" + targetId}
        onItemClick={contextMenuItemClick}
      />
    </div>
  );
}